import { render, staticRenderFns } from "./ParcelDeclaration.vue?vue&type=template&id=a6133dfc"
import script from "./ParcelDeclaration.vue?vue&type=script&lang=js"
export * from "./ParcelDeclaration.vue?vue&type=script&lang=js"
import style0 from "./ParcelDeclaration.vue?vue&type=style&index=0&id=a6133dfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports